/// <amd-module name="VSSUI/Components/Persona/Persona" />
import * as React from "react";
import { Coin, CoinSize } from "VSSUI/Coin";
import { IBasicIdentityRef, IIdentity, IPersonaProps } from "./Persona.Props";

export interface IPersonaState {
    imageError: boolean;
    imageLoaded: boolean;
    showIdentityCard: boolean;
}

/**
 * Renders a user's profile/identity/avatar image.
 */
export class Persona extends React.Component<IPersonaProps, IPersonaState> {
    private targetElement: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    constructor(props: IPersonaProps) {
        super(props);

        this.state = {
            imageError: false,
            imageLoaded: false,
            showIdentityCard: false
        };
    }

    public render(): JSX.Element {
        const { ariaLabel, ariaHidden, className, personaProvider, identity, role, size, tooltipProps } = this.props;

        const canShowPersonaCard: boolean = !!personaProvider && !!personaProvider.renderIdentityCard;
        const image = (identity as IIdentity).image || (identity as IBasicIdentityRef).imageUrl;

        // Getting the reference to the div around the image because the Callout within IdentityCard has positioning problems in some cases when passing in img element as the target
        return (
            <>
                <div aria-hidden={ariaHidden} ref={this.targetElement}>
                    <Coin
                        ariaLabel={ariaLabel}
                        className={className}
                        dataIsFocusable={canShowPersonaCard}
                        isTabStop={canShowPersonaCard}
                        onClick={canShowPersonaCard ? this.onClick : undefined}
                        displayName={identity.displayName || ""}
                        imageUrl={this.getServerImageFromSize(image)}
                        role={role}
                        size={(size as unknown) as CoinSize}
                        tooltipProps={tooltipProps}
                    />
                </div>
                {this.state.showIdentityCard &&
                    personaProvider &&
                    personaProvider.renderIdentityCard &&
                    personaProvider.renderIdentityCard(identity, personaProvider, this.hideIdentityCard, this.targetElement.current as HTMLElement)}
            </>
        );
    }

    public showIdentityCard = (): void => {
        if (this.props.personaProvider && this.props.personaProvider.renderIdentityCard) {
            this.setState({ showIdentityCard: true });
        }
    };

    private onClick = (ev: React.MouseEvent<HTMLDivElement>): void => {
        if (this.props.personaProvider && this.props.personaProvider.renderIdentityCard) {
            this.setState({ showIdentityCard: true });
        }

        ev.preventDefault();
    };

    private hideIdentityCard = (): void => {
        this.setState({ showIdentityCard: false });
    };

    private getServerImageFromSize(url?: string): string | undefined {
        if (!url) {
            return undefined;
        }

        if (this.props.size) {
            if (this.props.size <= CoinSize.size24) {
                return url + (url.indexOf("?") === -1 ? "?size=0" : "&size=0");
            } else if (this.props.size > CoinSize.size40) {
                return url + (url.indexOf("?") === -1 ? "?size=2" : "&size=2");
            }
        }

        return url;
    }
}
